import React from "react";
import { useNavigate } from "react-router-dom";

export default function VideoScreen({ onContinue, buttonLabel = "Login to Dashboard" }) {
  const navigate = useNavigate();

  const handleContinue = async () => {
    if (typeof onContinue === 'function') {
      await onContinue();
      return;
    }
    navigate('/');
  };

  return (
    <div className="min-h-screen flex flex-col justify-center items-center relative bg-gradient-to-br from-purple-500 via-indigo-600 to-pink-500">
      {/* Top left image */}
      <img
        src="/1.png" // Change to your image path
        alt="Logo"
        className="absolute top-4 left-4 w-12 h-12 sm:w-16 sm:h-16 object-contain drop-shadow-xl"
      />
      {/* Centered video */}
      <div className="flex flex-col items-center justify-center gap-6 w-full px-4">
          <div className="w-full max-w-xs sm:max-w-lg md:max-w-2xl lg:max-w-4xl rounded-2xl shadow-2xl border-4 border-white overflow-hidden">
            {/* Responsive video: uses provided CDN mp4, lazy loads, poster, controls */}
            <video
              src="https://cdn.insightos.co.uk/Welcome%20To%20The%20Future%20Of%20Work%20(2).mp4"
              controls
              preload="metadata"
              // some browsers ignore loading on <video>; preload=metadata is a safe lazy behavior
              loading="lazy"
              poster="/1.png"
              className="w-full max-w-screen-lg max-h-[60vh] rounded-xl object-contain lg:aspect-[3/2] lg:rounded-2xl mx-auto"
            />
          </div>
        <button
          onClick={handleContinue}
          className="w-full sm:w-auto px-6 py-3 bg-gradient-to-r from-indigo-500 to-purple-600 text-white font-bold rounded-lg shadow-lg hover:scale-105 transition-transform text-base sm:text-lg"
        >
          {buttonLabel}
        </button>
      </div>
    </div>
  );
}
